import { IPageResult } from 'src/entity/BaseResult';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import HttpService from './HttpService';
import APIS from 'src/constants/ApiConfig';
import { IOrderInfo } from 'src/entity/OrderEntity';

class NotifyService {
  /**
   * 获取待审核医生数量
   */
  getDoctorToApprove = (): Promise<IPageResult<IDoctorInfo[]>> => {
    return HttpService.get(`${APIS.domainApi(APIS.doctor.legacyMembers)}?to_approve&limit=1&is_verified__isnull=true&institution_type=0`);
  };

  /**
   * 获取带配置医生数量
   */
  getDoctorNeedConfigure = (): Promise<IPageResult<IDoctorInfo[]>> => {
    return HttpService.get(`${APIS.domainApi(APIS.doctor.legacyMembers)}?limit=1&check=true&is_need_configure=true&institution_type=0`);
  };

  /**
   * 获取待处理订单
   */
  getOrderPending = (): Promise<IPageResult<IOrderInfo[]>> => {
    return HttpService.get(`${APIS.domainUrl(APIS.drugStoreOrder)}?pay_status__in=30&limit=1`);
  };
}

export default new NotifyService();



// WEBPACK FOOTER //
// ./src/services/NotifyService.ts